var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calculation-container"},[_c('div',{staticClass:"box"},[_vm._v("\n    "+_vm._s(_vm.internalSign)+" "+_vm._s(Math.abs(_vm.number))+" "+_vm._s(_vm.$i18n.translateUnit(_vm.unit))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }